import { useEffect, useState } from 'react';
import { useChat } from '../context/Context';

export const useDialogSocketHandlers = ({
                                            socketInstance,
                                            dialogId,
                                            messagesRequest,
                                            setDialogActive,
                                            fetchDialogId,
                                            setIsAddYourDataVisible,
                                            setData,
                                            setWidgetShown,
                                            setIsOnline,
                                        }) => {
    const [userInteracted, setUserInteracted] = useState(false);

    useEffect(() => {
        const handleUserInteraction = () => {
            setUserInteracted(true);
            document.removeEventListener('click', handleUserInteraction);
        };

        document.addEventListener('click', handleUserInteraction);

        return () => {
            document.removeEventListener('click', handleUserInteraction);
        };
    }, []);

    useEffect(() => {
        if (!socketInstance) return;

        const ensureDialogReady = async () => {
            if (!dialogId?.data?.id) {
                try {
                    await fetchDialogId({ method: 'POST' });
                } catch (err) {
                    console.error('❌ Error fetching dialogId in socket handler:', err);
                }
            }
        };

        const dialogContactsHandler = () => setIsAddYourDataVisible(true);
        const dialogPassHandler = async () => {
            await ensureDialogReady();
            messagesRequest();
        };
        const dialogConnectHandler = async () => {
            await ensureDialogReady();
            messagesRequest();
        };
        const dialogStatusHandler = async ({ status }) => {
            await ensureDialogReady();
            localStorage.setItem('dialogStatus', status === 'unresolved' ? 'active' : 'closed');
            setDialogActive(status === 'unresolved');

            if (dialogId?.data?.id) messagesRequest();
            if (status === 'resolved') {
                setData(null);
            } else if (status === 'unresolved') {
                setWidgetShown(false);
            }
        };

        const dialogOperatorIsOnline = ({ status }) => {
            setIsOnline(status === 'online');
        };

        const dialogHandler = async (data) => {
            await ensureDialogReady();

            if (data.type !== 'visitor' && document.visibilityState !== 'visible') {
                if (userInteracted && window.messageAudio) {
                    try {
                        await window.messageAudio.play();
                    } catch (err) {
                        console.warn('🔇 Unable to play audio:', err);
                    }
                }

                window.parent.postMessage({ type: 'dialog.message', data }, '*');
            }

            messagesRequest();
            localStorage.setItem('dialogStatus', 'active');
            setDialogActive(true);
        };

        socketInstance.on('dialog.contacts', dialogContactsHandler);
        socketInstance.on('dialog.pass', dialogPassHandler);
        socketInstance.on('dialog.connect', dialogConnectHandler);
        socketInstance.on('dialog.status', dialogStatusHandler);
        socketInstance.on('dialog.operator', dialogOperatorIsOnline);
        socketInstance.on('dialog.message.send', dialogHandler);
        socketInstance.on('dialog.message.edit', messagesRequest);
        socketInstance.on('dialog.message.delete', ({ id }) => {
            setData((prev) => prev?.filter((m) => m.id !== id));
        });

        return () => {
            socketInstance.off('dialog.contacts', dialogContactsHandler);
            socketInstance.off('dialog.pass', dialogPassHandler);
            socketInstance.off('dialog.connect', dialogConnectHandler);
            socketInstance.off('dialog.status', dialogStatusHandler);
            socketInstance.off('dialog.operator', dialogOperatorIsOnline);
            socketInstance.off('dialog.message.send', dialogHandler);
            socketInstance.off('dialog.message.edit', messagesRequest);
            socketInstance.off('dialog.message.delete', messagesRequest);
        };
    }, [
        socketInstance,
        dialogId?.data?.id,
        messagesRequest,
        setDialogActive,
        setIsAddYourDataVisible,
        setData,
        setWidgetShown,
        setIsOnline,
        fetchDialogId,
        userInteracted,
    ]);
};
